const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  return `Basic ${btoa(`${username}:${password}`)}`;
}

/** Persists the org-level in-app purchase master switch from Billing. */
export async function updateOrgInAppPurchase({ userId, orgId, enabled }) {
  const response = await fetch(`${apiUrl}/api/organization/in-app-purchase`, {
    method: 'PATCH',
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
      Authorization: getBasicAuthHeader(),
    },
    body: JSON.stringify({
      userId,
      orgId,
      enabled: enabled ? 1 : 0,
    }),
  });
  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Request failed: ${response.status}`);
  }
  return response.json();
}
